import { RouteObject } from "react-router-dom";

import { AuthorizedRoute } from "src/authentication/AuthorizedRoute.tsx";
import { Scope, ScopeResource } from "src/authentication/PermissionsProvider.tsx";
import ErrorBoundary from "src/components/Errors/ErrorBoundary.tsx";
import DynamicViewSchemaProvider from "src/dynamic-view-renderer/DynamicViewSchemaProvider/DynamicViewSchemaProvider.tsx";
import { useT } from "src/internationalization";
import AlertDetailsPage from "src/pages/AlertDetails/AlertDetailsPage.tsx";
import AlertsPage from "src/pages/Alerts/AlertsPage.tsx";
import AlertsTab from "src/pages/Alerts/AlertsTab.tsx";

export const useAlertsRoutes = (): RouteObject[] => {
  const t = useT();

  return [
    {
      path: "alerts",
      element: (
        <AuthorizedRoute
          requiredPermissions={[{ resource: ScopeResource.ALERT, scopes: [Scope.VIEW] }]}
          pageTitle={t("page.alerts.title")}
        >
          <DynamicViewSchemaProvider>
            <AlertsPage />
          </DynamicViewSchemaProvider>
        </AuthorizedRoute>
      ),
      ErrorBoundary: ErrorBoundary,
      children: [
        {
          path: ":code",
          Component: AlertsTab,
          ErrorBoundary: ErrorBoundary,
        },
      ],
    },
    {
      path: "alert/:id",
      element: (
        <AuthorizedRoute
          requiredPermissions={[{ resource: ScopeResource.ALERT, scopes: [Scope.VIEW] }]}
          pageTitle={t("page.alerts.title")}
        >
          <DynamicViewSchemaProvider>
            <AlertDetailsPage />
          </DynamicViewSchemaProvider>
        </AuthorizedRoute>
      ),
      ErrorBoundary: ErrorBoundary,
    },
    {
      path: "alert/:id/:code",
      element: (
        <AuthorizedRoute
          requiredPermissions={[{ resource: ScopeResource.ALERT, scopes: [Scope.VIEW] }]}
          pageTitle={t("page.alerts.title")}
        >
          <DynamicViewSchemaProvider>
            <AlertDetailsPage />
          </DynamicViewSchemaProvider>
        </AuthorizedRoute>
      ),
      ErrorBoundary: ErrorBoundary,
    },
  ];
};
